import { FilterLabels } from 'components/common/GlobalFilterComponent/GlobalFilterComponent.utils';

interface IFilter {
    data: string[] | number[] | undefined;
    name: string;
}

/**
 * Generates a string representation of filters based on the widget filters data
 * Format: [first key] "is" [first value] " or " [second value] " and # more" (if more than 1 filter)
 */
export const generateFilterString = (widgetFiltersData: IFilter[]): string => {
    if (!widgetFiltersData || widgetFiltersData.length === 0) {
        return '';
    }

    const firstFilter = widgetFiltersData[0];
    const firstKey = FilterLabels[firstFilter.name] || firstFilter.name;
    const firstValues = firstFilter.data;

    if (!firstValues || firstValues.length === 0) {
        return '';
    }

    const firstValue = firstValues[0];
    const secondValue = firstValues[1];

    let result = `${firstKey} is ${firstValue}`;

    if (secondValue !== undefined) {
        result += ` or ${secondValue}`;
    }

    if (widgetFiltersData.length > 1) {
        result += ` and ${widgetFiltersData.length - 1} more`;
    }

    return result;
};
